const host = process.env.REACT_APP_HOST || 'http://127.0.0.1:8000';
const config = {
  apiUrl: `${host}/api`,
  clientApiUrl: `${host}/client-api/v1`,
  sandboxUrl: `${process.env.REACT_APP_SANDBOX}`,
  frontendUrl: host,
};

export default config;
